// import React, { useContext, useMemo, useState } from "react";
// import { GlobalContext } from "../../../Context/GlobalContext";
// import { Download, QrCode, Send } from "lucide-react";

// const CC_OPTS = [
//   { code: "1", label: "🇺🇸 +1 (United States)" },
//   { code: "44", label: "🇬🇧 +44 (United Kingdom)" },
//   { code: "91", label: "🇮🇳 +91 (India)" },
//   { code: "971", label: "🇦🇪 +971 (United Arab Emirates)" },
//   { code: "61", label: "🇦🇺 +61 (Australia)" },
//   { code: "1", label: "🇨🇦 +1 (Canada)" },
//   { code: "81", label: "🇯🇵 +81 (Japan)" },
//   { code: "49", label: "🇩🇪 +49 (Germany)" },
//   { code: "33", label: "🇫🇷 +33 (France)" },
//   { code: "39", label: "🇮🇹 +39 (Italy)" },
//   { code: "34", label: "🇪🇸 +34 (Spain)" },
//   { code: "7", label: "🇷🇺 +7 (Russia)" },
//   { code: "55", label: "🇧🇷 +55 (Brazil)" },
//   { code: "86", label: "🇨🇳 +86 (China)" },
//   { code: "82", label: "🇰🇷 +82 (South Korea)" },
//   { code: "31", label: "🇳🇱 +31 (Netherlands)" },
//   { code: "47", label: "🇳🇴 +47 (Norway)" },
//   { code: "46", label: "🇸🇪 +46 (Sweden)" },
//   { code: "41", label: "🇨🇭 +41 (Switzerland)" },
//   { code: "65", label: "🇸🇬 +65 (Singapore)" },
//   { code: "60", label: "🇲🇾 +60 (Malaysia)" },
//   { code: "63", label: "🇵🇭 +63 (Philippines)" },
//   { code: "62", label: "🇮🇩 +62 (Indonesia)" },
//   { code: "66", label: "🇹🇭 +66 (Thailand)" },
//   { code: "92", label: "🇵🇰 +92 (Pakistan)" },
//   { code: "880", label: "🇧🇩 +880 (Bangladesh)" },
//   { code: "94", label: "🇱🇰 +94 (Sri Lanka)" },
//   { code: "20", label: "🇪🇬 +20 (Egypt)" },
//   { code: "27", label: "🇿🇦 +27 (South Africa)" },
//   { code: "234", label: "🇳🇬 +234 (Nigeria)" },
//   { code: "254", label: "🇰🇪 +254 (Kenya)" },
//   { code: "212", label: "🇲🇦 +212 (Morocco)" },
//   { code: "351", label: "🇵🇹 +351 (Portugal)" },
//   { code: "43", label: "🇦🇹 +43 (Austria)" },
//   { code: "32", label: "🇧🇪 +32 (Belgium)" },
//   { code: "45", label: "🇩🇰 +45 (Denmark)" },
//   { code: "48", label: "🇵🇱 +48 (Poland)" },
//   { code: "420", label: "🇨🇿 +420 (Czech Republic)" },
//   { code: "353", label: "🇮🇪 +353 (Ireland)" },
//   { code: "358", label: "🇫🇮 +358 (Finland)" },
//   { code: "852", label: "🇭🇰 +852 (Hong Kong)" },
//   { code: "853", label: "🇲🇴 +853 (Macau)" },
//   { code: "90", label: "🇹🇷 +90 (Turkey)" },
//   { code: "972", label: "🇮🇱 +972 (Israel)" },
//   { code: "64", label: "🇳🇿 +64 (New Zealand)" },
//   { code: "98", label: "🇮🇷 +98 (Iran)" },
//   { code: "968", label: "🇴🇲 +968 (Oman)" },
//   { code: "974", label: "🇶🇦 +974 (Qatar)" },
//   { code: "966", label: "🇸🇦 +966 (Saudi Arabia)" },
//   { code: "973", label: "🇧🇭 +973 (Bahrain)" },
// ];


// export default function WhatsappQrGenerator() {
//   const { api, AllClients = [] } = useContext(GlobalContext);
//   const clients = useMemo(
//     () =>
//       AllClients.map((c) => ({
//         value: c.us_code,
//         label: `${c.us_code} — ${c.organization_name || c.us_name || c.us_loginid || ""}`,
//       })),
//     [AllClients]
//   );

//   const [form, setForm] = useState({
//     userid: clients[0]?.value || "",
//     cc: "91",
//     number: "",
//     message: "Hi",
//   });
//   const [loading, setLoading] = useState(false);
//   const [qrUrl, setQrUrl] = useState("");
//   const [error, setError] = useState("");

//   const fullNumber = `${form.cc}${form.number}`.replace(/\D/g, "");

//   const submit = async (e) => {
//     e.preventDefault();
//     setError("");
//     if (!form.userid) return setError("Select a client (User ID).");
//     if (!form.number || fullNumber.length < 8) return setError("Enter a valid phone number.");

//     setLoading(true);
//     setQrUrl("");
//     try {
//       const { data } = await api.post(`/Whatsapp/v2.0/generateWhatsappQRCode`, {
//         userid: form.userid,
//         whatsappNumber: fullNumber,
//         message: form.message || "Hi",
//       });
//       if (data?.responseCode === "00") {
//         setQrUrl(data?.response?.data || "");
//       } else {
//         setError(data?.responseMessage || "Failed to generate QR");
//       }
//     } catch {
//       setError("Failed to generate QR");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const download = async () => {
//     if (!qrUrl) return;
//     try {
//       const res = await fetch(qrUrl, { mode: "cors" });
//       const blob = await res.blob();
//       const url = URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `${form.userid}_WHATSAPP_QR.png`;
//       document.body.appendChild(a);
//       a.click();
//       a.remove();
//       URL.revokeObjectURL(url);
//     } catch {
//       window.open(qrUrl, "_blank", "noopener");
//     }
//   };

//   return (
//     <div className="rounded-2xl border border-gray-100 bg-white p-4 md:p-5">
//       <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
//         {/* LEFT: FORM */}
//         <form onSubmit={submit} className="space-y-4">
//           <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
//             {/* UserID */}
//             <div className="min-w-0 md:col-span-2">
//               <label className="mb-1 block text-xs font-medium text-gray-600">User ID (Client)</label>
//               <select
//                 className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
//                 value={form.userid}
//                 onChange={(e) => setForm((s) => ({ ...s, userid: e.target.value }))}
//               >
//                 {clients.length === 0 && <option value="">No clients</option>}
//                 {clients.map((opt) => (
//                   <option key={opt.value} value={opt.value}>
//                     {opt.label}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             {/* Phone */}
//             <div className="min-w-0">
//               <label className="mb-1 block text-xs font-medium text-gray-600">Country Code</label>
//               <select
//                 className="w-full rounded-lg border border-gray-200 bg-white px-2 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
//                 value={form.cc}
//                 onChange={(e) => setForm((s) => ({ ...s, cc: e.target.value }))}
//               >
//                 {CC_OPTS.map((o) => (
//                   <option key={o.code} value={o.code}>
//                     {o.label}
//                   </option>
//                 ))}
//               </select>
//             </div>
//             <div className="min-w-0">
//               <label className="mb-1 block text-xs font-medium text-gray-600">WhatsApp Number</label>
//               <input
//                 className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
//                 placeholder="8920648347"
//                 value={form.number}
//                 onChange={(e) => setForm((s) => ({ ...s, number: e.target.value }))}
//               />
//             </div>

//             {/* Message */}
//             <div className="min-w-0 md:col-span-2">
//               <label className="mb-1 block text-xs font-medium text-gray-600">Message</label>
//               <input
//                 className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
//                 value={form.message}
//                 onChange={(e) => setForm((s) => ({ ...s, message: e.target.value }))}
//                 placeholder="Hi"
//               />
//             </div>
//           </div>

//           {error ? <p className="text-xs font-medium text-rose-600">{error}</p> : null}

//           <div className="flex flex-wrap items-center gap-2">
//             <button
//               type="submit"
//               disabled={loading}
//               className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
//             >
//               <Send size={16} /> {loading ? "Generating…" : "Generate QR"}
//             </button>

//             {qrUrl && (
//               <button
//                 type="button"
//                 onClick={download}
//                 className="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-50"
//               >
//                 <Download size={16} /> Download
//               </button>
//             )}
//           </div>
//         </form>

//         {/* RIGHT: PREVIEW */}
//         <div className="flex items-center justify-center">
//           <div className="w-full max-w-sm rounded-xl border border-dashed p-4 text-center">
//             <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-lg bg-emerald-50 text-emerald-600">
//               <QrCode size={18} />
//             </div>
//             <div className="text-sm font-semibold text-gray-900">
//               {qrUrl ? "QR Code generated successfully" : "Your QR code will appear here"}
//             </div>
//             {qrUrl ? (
//               <img
//                 src={qrUrl}
//                 alt="WhatsApp QR"
//                 className="mx-auto mt-4 w-full max-w-[280px] rounded-lg border object-contain"
//               />
//             ) : (
//               <p className="mx-auto mt-4 max-w-xs text-xs text-gray-500">
//                 Select client, enter number &amp; generate to preview/download the QR.
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useContext, useMemo, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { Download, QrCode, Send } from "lucide-react";
import useDashboard from "../../Services/DashboardServices/useDashboard";
import ClientSearchSelect from "../../common/ClientSearchSelect";

const CC_OPTS = [
  { code: "1", label: "🇺🇸 +1 (United States)" },
  { code: "44", label: "🇬🇧 +44 (United Kingdom)" },
  { code: "91", label: "🇮🇳 +91 (India)" },
  { code: "971", label: "🇦🇪 +971 (United Arab Emirates)" },
  { code: "61", label: "🇦🇺 +61 (Australia)" },
  { code: "1", label: "🇨🇦 +1 (Canada)" }, // same code "1" → key clash tha
  { code: "81", label: "🇯🇵 +81 (Japan)" },
  { code: "49", label: "🇩🇪 +49 (Germany)" },
  { code: "33", label: "🇫🇷 +33 (France)" },
  { code: "39", label: "🇮🇹 +39 (Italy)" },
  { code: "34", label: "🇪🇸 +34 (Spain)" },
  { code: "7", label: "🇷🇺 +7 (Russia)" },
  { code: "55", label: "🇧🇷 +55 (Brazil)" },
  { code: "86", label: "🇨🇳 +86 (China)" },
  { code: "82", label: "🇰🇷 +82 (South Korea)" },
  { code: "31", label: "🇳🇱 +31 (Netherlands)" },
  { code: "47", label: "🇳🇴 +47 (Norway)" },
  { code: "46", label: "🇸🇪 +46 (Sweden)" },
  { code: "41", label: "🇨🇭 +41 (Switzerland)" },
  { code: "65", label: "🇸🇬 +65 (Singapore)" },
  { code: "60", label: "🇲🇾 +60 (Malaysia)" },
  { code: "63", label: "🇵🇭 +63 (Philippines)" },
  { code: "62", label: "🇮🇩 +62 (Indonesia)" },
  { code: "66", label: "🇹🇭 +66 (Thailand)" },
  { code: "92", label: "🇵🇰 +92 (Pakistan)" },
  { code: "880", label: "🇧🇩 +880 (Bangladesh)" },
  { code: "94", label: "🇱🇰 +94 (Sri Lanka)" },
  { code: "20", label: "🇪🇬 +20 (Egypt)" },
  { code: "27", label: "🇿🇦 +27 (South Africa)" },
  { code: "234", label: "🇳🇬 +234 (Nigeria)" },
  { code: "254", label: "🇰🇪 +254 (Kenya)" },
  { code: "212", label: "🇲🇦 +212 (Morocco)" },
  { code: "351", label: "🇵🇹 +351 (Portugal)" },
  { code: "43", label: "🇦🇹 +43 (Austria)" },
  { code: "32", label: "🇧🇪 +32 (Belgium)" },
  { code: "45", label: "🇩🇰 +45 (Denmark)" },
  { code: "48", label: "🇵🇱 +48 (Poland)" },
  { code: "420", label: "🇨🇿 +420 (Czech Republic)" },
  { code: "353", label: "🇮🇪 +353 (Ireland)" },
  { code: "358", label: "🇫🇮 +358 (Finland)" },
  { code: "852", label: "🇭🇰 +852 (Hong Kong)" },
  { code: "853", label: "🇲🇴 +853 (Macau)" },
  { code: "90", label: "🇹🇷 +90 (Turkey)" },
  { code: "972", label: "🇮🇱 +972 (Israel)" },
  { code: "64", label: "🇳🇿 +64 (New Zealand)" },
  { code: "98", label: "🇮🇷 +98 (Iran)" },
  { code: "968", label: "🇴🇲 +968 (Oman)" },
  { code: "974", label: "🇶🇦 +974 (Qatar)" },
  { code: "966", label: "🇸🇦 +966 (Saudi Arabia)" },
  { code: "973", label: "🇧🇭 +973 (Bahrain)" },
];

export default function WhatsappQrGenerator() {
  const { generateWhatsappQRCode } = useDashboard();

  const { api, AllClients = [] } = useContext(GlobalContext);
  const clients = useMemo(
    () =>
      AllClients.map((c) => ({
        value: c.us_code,
        label: `${c.us_code} — ${c.organization_name || c.us_name || c.us_loginid || ""
          }`,
      })),
    [AllClients]
  );

  const [form, setForm] = useState({
    userid: clients[0]?.value || "",
    cc: "91",
    number: "",
    message: "Hi",
  });
  const [loading, setLoading] = useState(false);
  const [qrUrl, setQrUrl] = useState("");
  const [error, setError] = useState("");

  const fullNumber = `${form.cc}${form.number}`.replace(/\D/g, "");

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (!form.userid)
      return setError("Select a client (User ID).");

    if (!form.number || fullNumber.length < 8)
      return setError("Enter a valid phone number.");

    setLoading(true);
    setQrUrl("");

    const result = await generateWhatsappQRCode({
      userid: form.userid,
      whatsappNumber: fullNumber,
      message: form.message,
    });

    if (result.success) {
      setQrUrl(result.qrUrl);
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  const download = async () => {
    if (!qrUrl) return;
    try {
      const res = await fetch(qrUrl, { mode: "cors" });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${form.userid}_WHATSAPP_QR.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch {
      window.open(qrUrl, "_blank", "noopener");
    }
  };

  return (
    <div className="rounded-2xl bg-white ">
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        {/* LEFT: FORM */}
        <form onSubmit={submit} className="space-y-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            {/* UserID */}
            <div className="min-w-0 md:col-span-2">
              <label className="mb-1 block text-xs font-medium text-gray-600">
                User ID (Client)
              </label>
              <ClientSearchSelect
                clients={(clients || []).map((opt) => ({
                  us_code: opt.value,
                  us_name: opt.label,
                }))}
                value={form.userid}
                className="w-full [&>button]:rounded-lg [&>button]:border-gray-200 [&>button]:h-[38px]"
                placeholder={clients.length === 0 ? "No clients" : "Select client"}
                onChange={(client) =>
                  setForm((s) => ({
                    ...s,
                    userid: client?.us_code || "",
                  }))
                }
              />
            </div>

            {/* Phone */}
            <div className="min-w-0">
              <label className="mb-1 block text-xs font-medium text-gray-600">
                Country Code
              </label>
              <select
                className="w-full rounded-lg border border-gray-200 bg-white px-2 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
                value={form.cc}
                onChange={(e) =>
                  setForm((s) => ({ ...s, cc: e.target.value }))
                }
              >
                {CC_OPTS.map((o, idx) => (
                  <option key={`${o.code}-${idx}`} value={o.code}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="min-w-0">
              <label className="mb-1 block text-xs font-medium text-gray-600">
                WhatsApp Number
              </label>
              <input
                className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
                placeholder="8920648347"
                value={form.number}
                onChange={(e) =>
                  setForm((s) => ({ ...s, number: e.target.value }))
                }
              />
            </div>

            {/* Message */}
            <div className="min-w-0 md:col-span-2">
              <label className="mb-1 block text-xs font-medium text-gray-600">
                Message
              </label>
              <input
                className="w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm outline-none ring-emerald-200 focus:ring-2"
                value={form.message}
                onChange={(e) =>
                  setForm((s) => ({ ...s, message: e.target.value }))
                }
                placeholder="Hi"
              />
            </div>
          </div>

          {error ? (
            <p className="text-xs font-medium text-rose-600">{error}</p>
          ) : null}

          <div className="flex flex-wrap items-center gap-2">
            <button
              type="submit"
              disabled={loading}
              className="inline-flex items-center gap-2 rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white hover:bg-emerald-700 disabled:opacity-60"
            >
              <Send size={16} /> {loading ? "Generating…" : "Generate QR"}
            </button>

            {qrUrl && (
              <button
                type="button"
                onClick={download}
                className="inline-flex items-center gap-2 rounded-lg border px-3 py-2 text-sm hover:bg-gray-50"
              >
                <Download size={16} /> Download
              </button>
            )}
          </div>
        </form>

        {/* RIGHT: PREVIEW */}
        <div className="flex items-center justify-center">
          <div className="w-full max-w-sm rounded-xl border border-dashed p-4 text-center">
            <div className="mx-auto mb-3 grid h-10 w-10 place-items-center rounded-lg bg-emerald-50 text-emerald-600">
              <QrCode size={18} />
            </div>
            <div className="text-sm font-semibold text-gray-900">
              {qrUrl
                ? "QR Code generated successfully"
                : "Your QR code will appear here"}
            </div>
            {qrUrl ? (
              <img
                src={qrUrl}
                alt="WhatsApp QR"
                className="mx-auto mt-4 w-full max-w-[280px] rounded-lg border object-contain"
              />
            ) : (
              <p className="mx-auto mt-4 max-w-xs text-xs text-gray-500">
                Select client, enter number &amp; generate to preview/download
                the QR.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
